// extracted by mini-css-extract-plugin
module.exports = {"container":"mobile_container__3FY47","header":"mobile_header__1S8UW","desc":"mobile_desc__3aq_O","comingSoon":"mobile_comingSoon__3xPYE","button":"mobile_button__2iUBW"};